import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import HighlightSection from './components/HighlightSection';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <HighlightSection />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}